import { createFileRoute, getRouteApi } from "@tanstack/react-router"

import { FileRequestsPage } from "@/components/terminal/file-requests-page"

const terminalRoute = getRouteApi("/_terminal/terminal")

const Requests = () => {
  const { rows, fileRequests } = terminalRoute.useLoaderData()
  const { portfolio } = terminalRoute.useSearch()
  if (!portfolio) return null
  return (
    <FileRequestsPage
      portfolioSlug={portfolio}
      fileRequests={fileRequests}
      rows={rows}
    />
  )
}

// The Portfolio's File Requests in Home's center well, opened from the
// account menu; the layout loads them with the Portfolio rows.
export const Route = createFileRoute("/_terminal/terminal/requests")({
  staticData: { shellMode: "page" },
  component: Requests,
})
